
<script>
  import { 
    Row, Column, Block, Text, Icon, Image, Popup, 
    TextInput, Link, Toast,
  } from 'bastone'
  import { colors } from '../consts'
  import { Context, currentUser, bodyWidth, isDesktop, notify } from '../context'
  import MyButton from '../components/button.svelte'
  import Confirm from '../components/confirm.svelte'
  import Avatar from '../components/avatar.svelte'
  import { onDestroy } from 'svelte'
  import { User, UserOrder } from '../models'
  import { copyText } from '../utils';

  export let buttonType = 'chat'
  export let coins = 0
  let confirm = null

  let showBuy = false
  let showPay = false
  let showInvite = false
  let showWeixin = false

  const buyTypes = {PRO: 1, COIN: 0}
  let buyType = buyTypes.PRO
  let buyCount = 90

  let payQrcodeUrl = ''
  let bindQrcodeUrl = ''
  let order = null
  let timerId = null
  let timerCount = 0
  let inviteMessage = ''
  let inviteCount = 0
  let rewardCoins = 0

  let menuItems = [
    {title: '个人信息', icon: 'prompt', click: ()=>{location.href = '/profile'}},
    {title: '充值续费', icon: 'discount', click: ()=>{showBuy=true}},
    {title: '邀请好友', icon: 'link', click: ()=>{showInvite=true}},
    {title: '绑定微信', icon: 'scanning', click: openWeixin},
    {title: '收藏夹', icon: 'favorite', click: ()=>{location.href = '/favorite'}},
    {title: '退出登陆', icon: 'sign-out', click: logout},
  ]

  let proPlans = [
    {text: '月卡45元', count: 30},
    {text: '季卡108元', count: 90, tag: '8折'},
    {text: '年卡360元', count: 360, tag: '66折'},
  ]

  let coinPlans = [
    {text: '1000点6元', count: 1000},
    {text: '10000点36元', count: 10000, tag: '限时6折'},
  ]

	const unsubscribe = currentUser.subscribe(user => {
    if (user) {
      inviteMessage = `deeppp.com/?u=${user.invite_code} 国内最好用的ChatGPT,支持自定义BOT/GPT4/微信/联网/私有数据集,免费体验无限白瓢`
      inviteCount = user.invite_count
      rewardCoins = user.reward_coins
      coins = user.coins
    }
	})
  onDestroy(unsubscribe)

  async function openWeixin() {
    let res = await User.get_wx_qrcode()
    bindQrcodeUrl = res ? res.url : ''
    showWeixin = true
  }
  
  function logout() {
    confirm.show('确定要退出登陆吗？', ()=>{
      Context.unsetUser()
      location.href = '/'
    })
  }

  async function createOrder() {
    order = new UserOrder({type: buyType, count: buyCount})
    if (!await order.create()) {
      return
    }

    payQrcodeUrl = order.qrcode_url
    showBuy = false
    showInvite = false
    showPay = true

    timerId = setInterval(async () => {
      if (!showPay || !order) {
        return
      }
      timerCount += 1
      let newOrder = await UserOrder.getOne(order.id)
      if (newOrder.status == 2) {
        closeAll()
        Context.init()
        return 
      } else if (timerCount > 400) {
        closeAll()
      }
    }, 1500)
  }

  function closeAll(reset=true) {
    showBuy = false
    showPay = false
    showInvite = false
    payQrcodeUrl = ''
    order = ''
    timerCount = 0
    
    if (reset) {
      buyType = buyTypes.PRO
      buyCount = 90
    }
    
    if (timerId != null) {
      clearInterval(timerId)
      timerId = null
    }
  }


</script>

<Confirm bind:this={confirm}/>

<Popup name=buy bind:showing={showBuy} center={true} backgroundColor={colors.translucent} clickDismiss={false}>
  <Block width={$isDesktop?'32rem':'24rem'} padding={$isDesktop?'1.4rem':'0.6rem'} backgroundColor=white>
    <Row width=100%>
      <Image url=/images/charge.png height=1.1rem/>
      <Block width=0.5rem/>
      <Text size=1.1rem lineHeight=1.5rem>开启AI+新时代</Text>
      <Block expand=1/>
      <Icon name=close size=1.5rem cursor=pointer on:click={closeAll}/>
    </Row>
    <Block height=0.8rem/>
    <Row width=100% height=18rem>
      <Block 
        width=50% height=100% padding={$isDesktop?'0.8rem':'0.4rem'} border={buyType==buyTypes.PRO?2:1}
        borderColor={buyType==buyTypes.PRO?colors.black:colors.lightGray}
        on:click={()=>{buyType=buyTypes.PRO;buyCount=90}}
      >
        <Row>
          <Text size=1.2rem lineHeight=1.4rem bold={buyType==buyTypes.PRO}>{$currentUser.is_pro?'续费':'开通'}会员</Text>
          <Block width=0.3rem/>
          <Block backgroundColor={colors.black} height=1.4rem padding={{horizontal:'0.2rem'}}>
            <Text size=1rem bold=1 lineHeight=1.4rem color=white fontFamily=Consolas>PRO</Text>
          </Block>
          
        </Row>
        
        <Block height=0.8rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>每天100次免费对话</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>每天<b>5次GPT4</b>对话</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>平均一次≈0.01元</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>创建<b>数据集BOT</b></Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>使用PRO专属BOT</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>更多新特性开发中</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>额外<b>赠送{buyType==buyTypes.PRO?buyCount*20:1800}点</b></Text>
        </Row>
        
      </Block>
      <Block width={$isDesktop?'1.2rem':'0.4rem'}/>

      <Block width=50% height=100% padding={$isDesktop?'0.8rem':'0.4rem'} border={buyType==buyTypes.COIN?2:1}
        borderColor={buyType==buyTypes.COIN?colors.black:colors.lightGray}
        on:click={()=>{buyType=buyTypes.COIN;buyCount=10000}}
      >
        <Row>
          <Text size=1.2rem lineHeight=1.4rem bold={buyType==buyTypes.COIN}>充值点数</Text>
          <Block width=0.3rem/>
          <Image url='/images/coin.png' height=1.2rem/>
        </Row>
        
        <Block height=0.8rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>按量付费，随用随充</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>1点=100Token(约70字)</Text>
        </Row>
        <Block height=0.6rem/>
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>平均一次≈0.05元</Text>
        </Row>
        <Block height=0.6rem/>
        
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text lineHeight=1.4rem>创建普通BOT</Text>
        </Row>
        <Block height=0.6rem/>
        
        
        <Row>
          <Image url='/images/check.png' height=1rem/>
          <Block width=0.4rem/>
          <Text 
            lineHeight=1.4rem decoration=underline cursor=pointer selectable={false}
            on:click={()=>{showBuy=false;showInvite=true}}
          >邀好友免费得<b>1000点</b></Text>
        </Row>
        
      </Block>

      


    </Row>
    <Block height=1rem/>

    <Text size=1.1rem>选择套餐</Text>
    <Block height=0.8rem/>
    <Row width=100%>
      {#each buyType==buyTypes.PRO?proPlans:coinPlans as plan, i}
      <Block 
        border={buyCount==plan.count?2:1} padding={{horizontal:$isDesktop?'0.8rem':'0.5rem',vertical:'0.5rem'}} 
        cursor=pointer display=flex xAlign=center selectable={false}
        borderColor={buyCount==plan.count?colors.black:colors.lightGray}
        on:click={()=>{buyCount=plan.count}}
      >
        <Text bold={buyCount==plan.count}>{plan.text}</Text>
        {#if plan.tag}
        <Block width=0.4rem/>
        <Block backgroundColor={colors.red} padding={{horizontal:'0.2rem'}} height=1rem display=flex xAlign=center>
          <Text size=0.8rem color=white>{plan.tag}</Text>
        </Block>
        {/if}
      </Block>
      {#if i != proPlans.length - 1}
      <Block width=0.8rem/>
      {/if}
      {/each}
    </Row>
    <Block height=1.2rem/>
    <Row>
      <MyButton 
        width=100% height=2.6rem fill=1 iconSize=1.1rem icon=scanning
        on:click={()=>{createOrder(1)}}
      >
        <Text lineHeight=1.2rem>扫码支付</Text>
      </MyButton>
    </Row>
  </Block>
</Popup>


<Popup name=invite bind:showing={showInvite} center={true} backgroundColor={colors.translucent} clickDismiss={false}>
  <Block width={$isDesktop?'26rem':'24rem'} padding={{horizontal:($isDesktop?'1.5rem':'1rem')}} backgroundColor=white>
    <Column width=100%>
      <Block height=1rem/>
      <Row>
        <Row expand=1 align=center>
          <Block width=1rem/>
          <Text lineHeight=2.7rem size=1.4rem bold={showInvite}>邀请好友立得<b>1000</b>点</Text>
        </Row>
        <Block on:click={closeAll} cursor=pointer><Icon name=close size=1.5rem/></Block>
      </Row>
      <Block height=1.2rem/>
      <Row width=100%>
        <TextInput 
          border=2 borderColor={colors.black} iconSize=1.4rem space=0.4rem
          height=2.2rem width=74% fontSize=1rem readonly=1
          value={inviteMessage}
        /><MyButton 
          height=2.2rem width=26% leftBorder=0 fontSize=1rem bold={false}
          on:click={()=>{copyText(inviteMessage);notify('已复制')}} fill=1
        >复制链接</MyButton>
      </Row>
      <Block height=1rem/>
      <Text lineHeight=1.5rem>每个好友注册并使用，你获得300点奖励</Text>
      <Text lineHeight=1.5rem>每个好友消费任意金额，你获得<b>700</b>点奖励</Text>
      <Text lineHeight=1.5rem>已邀请{inviteCount}位，累计获得{rewardCoins}点</Text>
      <Block height=1.5rem/>
    </Column>
  </Block>
</Popup>

<Popup name=pay bind:showing={showPay} center={true} backgroundColor={colors.translucent} clickDismiss={false}>
  <Block width={$isDesktop?'24rem':'22rem'} padding={{horizontal:($isDesktop?'1.5rem':'1rem')}} backgroundColor=white>
    <Column width=100%>
      <Block height=1rem/>
      <Row>
        <Row expand=1 align=center>
          <Block width=1rem/>
          <Text size=1.5rem fontWeight=bold color={colors.green}>微信扫码支付</Text>
        </Row>
        <Block on:click={()=>{closeAll(false);showBuy=true}} cursor=pointer><Icon name=close size=1.5rem/></Block>
      </Row>

      <Column width=100% xAlign=center>
        <Block height=0.5rem/>
        <Image width=80% url={payQrcodeUrl}/>
        <Text size=1.2rem>支付完成后会自动关闭并刷新</Text>
        <Block height=0.5rem/>
        <Text size=1rem bold=1>暂不支持移动端,请用电脑或另一手机扫屏</Text>
      </Column>
      <Block height=1.5rem/>
    </Column>
  </Block>
</Popup>

<Popup name=weixin bind:showing={showWeixin} center={true} backgroundColor={colors.translucent} clickDismiss={false}>
  <Block width=20rem padding=1.5rem backgroundColor=white>
    <Column width=100%>
      <Row>
        <Row expand=1 align=center>
          <Block width=1rem/>
          <Text size=1.5rem fontWeight=bold color={colors.green}>在微信中与AI对话</Text>
        </Row>
        <Block on:click={()=>{showWeixin=false}} cursor=pointer><Icon name=close size=1.5rem/></Block>
      </Row>

      <Column width=100% xAlign=center>
        <Block height=0.5rem/>
        <Image width=90% url={bindQrcodeUrl}/>
        <Block height=0.5rem/>
        <Text size=1.2rem>微信扫码关注开聊，<b>支持语音</b></Text>
      </Column>
    </Column>
  </Block>
</Popup>


<Row minHeight={$isDesktop?'5rem':'3.4rem'} width=100% align=center backgroundColor={colors.black}>
  <Row height=100% width={$bodyWidth} minWidth=80%>
    <Link url='/' newWindow=1>
      <Image height={$isDesktop?'3.2rem':'2.2rem'} url='/images/logow.png' cursor=pointer/>
    </Link>

    {#if $isDesktop}
    <Block width=1.5rem/>
      {#if buttonType == 'home'}
      <Link url='/home'>
        <MyButton 
          height=2rem border=1.5 width=6.8rem color=white borderColor=white icon=modular
          iconSize=1.2rem fontSize=1rem space=0.3rem
        >BOT广场</MyButton>
      </Link>
      {:else if buttonType == 'back'}
      <MyButton 
          height=2rem border=1.5 width=4.8rem color=white borderColor=white icon=back
          iconSize=1rem fontSize=1rem space=0.3rem
          on:click={()=>(history.length>1?history.back():location.href='/chat')}
        >返回</MyButton>
      {:else}
      <Link url='/chat'>
        <MyButton 
          height=2rem border=1.5 width=7.2rem color=white borderColor=white icon=comment
          iconSize=1.2rem fontSize=1rem space=0.3rem
        >进入对话</MyButton>
      </Link>
      {/if}
    {:else}
    <Block width=0.6rem/>
      {#if buttonType == 'home'}
      <Link url='/home'>
        <MyButton 
          height=1.6rem border=1 width=1.8rem color=white borderColor=white icon=modular
          iconSize=1rem space=0
        ></MyButton>
      </Link>
      {:else if buttonType == 'back'}
      <MyButton 
        height=1.6rem border=1 width=1.8rem color=white borderColor=white icon=back
        iconSize=1rem space=0
        on:click={()=>(history.length>1?history.back():location.href='/chat')}
      ></MyButton>
      {:else}
      <Link url='/chat'>
        <MyButton 
          height=1.6rem border=1 width=1.8rem color=white borderColor=white icon=comment
          iconSize=1rem space=0
        ></MyButton>
      </Link>
      {/if}
    {/if}
    
    <Block expand=1/>

    {#if !$currentUser.wx_id}
    <Block width={$isDesktop?'0.6rem':'0.4rem'}/>
    <MyButton 
      height=1.6rem border=1 width=4.2rem color=white borderColor=white icon=mobile-phone
      iconSize=1rem space={$isDesktop?'0.1rem':0}
      on:click={openWeixin}
    >
      <Text size=0.8rem lineHeight=1.2rem>手机版</Text>
    </MyButton>
    {/if}

    <Block width={$isDesktop?'0.6rem':'0.4rem'}/>
    <Block cursor=pointer on:click={()=>showBuy=true}>
      <Row>
        <Block width=0.5rem/>
        {#if $currentUser?.is_pro && ($isDesktop || $currentUser.remain_quota > 0)}
        <Image width=1.6rem url='/images/cardw.png'/>
        <Block width=0.4rem/>
          {#if $isDesktop}
          <Text size=1.2rem color=white lineHeight=2rem bold=1 >{$currentUser?.remain_quota}/{$currentUser?.quota}</Text>
          {:else}
          <Text size=1.2rem color=white lineHeight=2rem bold=1 >{$currentUser?.remain_quota}</Text>
          {/if}
        <Block width={$isDesktop?'1.2rem':'0.5rem'}/>
        {:else if !$currentUser.is_pro && $isDesktop}
        <MyButton 
          height=1.6rem border=1 width={$isDesktop?'5.4rem':'3.4rem'} color=white borderColor=white icon=rise-filling
          iconSize=1rem space=0.2rem
        >
          <Text size=0.8rem lineHeight=1.2rem>{$isDesktop?'开通':''}<b>PRO</b></Text>
        </MyButton>
        <Block width={$isDesktop?'1.2rem':'0.5rem'}/>
        {/if}
        
        {#if $isDesktop || $currentUser.remain_quota == 0}
        <Image width=1.2rem url='/images/coinw.png'/>
        <Block width={$isDesktop?'0.4rem':'0.2rem'}/>
        <Text size=1.2rem color=white lineHeight=2rem bold=1>{coins}</Text>
        {/if}
      </Row>
    </Block>
    
    <Block width={$isDesktop?'1.6rem':'0.6rem'}/>
    <Toast left={null} right=-1rem top={$isDesktop?'5rem':'3.4rem'}>
      <Row slot=target height={$isDesktop?'5rem':'3.4rem'}>
        <Avatar user={$currentUser}/>
      </Row>
      
      <Block 
        slot=toast color=white selectable={false} cursor=pointer 
        topBorder=1 backgroundColor={colors.black}
      >
        <Block 
          hoverBgColor={colors.lightBlack} padding={{horizontal:'1rem',vertical:'0.2rem'}}
          bottomBorder=1 borderColor={colors.gray}
        >
          <Row height=3.2rem width=100%>
            <Avatar user={$currentUser}/>
            <Block width=0.5rem/>
            <Column>
              <Text color=white size=0.9rem>{$currentUser?.name}</Text>
              <Block height=0.1rem width=0/>
              <Row>
                {#if $currentUser?.is_pro}
                <Block backgroundColor=white display=flex xAlign=center height=1rem padding={{horizontal:'0.2rem'}}>
                  <Text size=0.75rem bold=1 color={colors.black} fontFamily=Consolas>PRO会员</Text>
                </Block>
                <Block width=0.3rem/>
                <Text size=0.75rem bold=1 color=white>{$currentUser.pro_days}天</Text>
                {:else}
                <Text color=white size=0.75rem>非PRO会员</Text>
                {/if}
              </Row>
            </Column>
          </Row>
        </Block>


        {#each menuItems as item}
        <Block 
          hoverBgColor={colors.lightBlack} padding={{horizontal:'1rem',vertical:'0.2rem'}}
          on:click={item.click}
        >
          <Row height=2.8rem width=100%>
            <Icon name={item.icon} size=1.1rem/>
            <Block width=0.6rem/>
            <Text size=1.1rem lineHeight=1.4rem>{item.title}</Text>
            <Block width=0.6rem/>
          </Row>
        </Block>
        {/each}
      </Block>
    </Toast>
  </Row>
</Row>